interface OptionValueLike {
  id?: string;
  order?: number;
}

interface OptionGroupLike {
  id?: string;
  order?: number;
  values?: OptionValueLike[] | null;
}

/**
 * Returns the default option-value id for each option group: the first value by
 * `order`. This provides sensible defaults for one-click add-to-cart WITHOUT
 * needing an "isDefault" column in the database, admins control the default
 * purely by ordering the desired value first in each group.
 *
 * Returns an empty array if the product has no option groups (or their values
 * weren't loaded), in which case callers should fall back to opening the product
 * page so the customer can choose.
 */
export function getDefaultOptionValueIds(
  product: { optionGroups?: OptionGroupLike[] | null } | null | undefined
): string[] {
  const groups = product?.optionGroups ?? [];
  return groups
    .map((group) => {
      const values = [...(group.values ?? [])].sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0)
      );
      return values[0]?.id;
    })
    .filter((id): id is string => Boolean(id));
}
